import { Link } from 'gatsby'

export const getLinkComponentAndProps = (linkTo: SOG.Props.LinkTo) => {
  return linkTo.isExternal
    ? { component: 'a', href: linkTo.url, target: '_blank', rel: 'noreferrer' }
    : { component: Link, to: linkTo.url }
}
